import { render, staticRenderFns } from "./pdf-viewer.html?vue&type=template&id=176b7370&scoped=true&external"
import script from "./pdf-viewer.js?vue&type=script&lang=js&external"
export * from "./pdf-viewer.js?vue&type=script&lang=js&external"
import style0 from "./pdf-viewer.scss?vue&type=style&index=0&id=176b7370&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176b7370",
  null
  
)

export default component.exports